module.exports = __webpack_public_path__ + "static/media/29FUNOV16.791518ba.jpg";